import React from 'react'
const SmartFilterContext = React.createContext(null)
export default SmartFilterContext